function Watcher(vm, node, name, nodeType) {
  if (!this.nodeTpl) {
    // 缓存所有模板节点
    this.nodeTpl = {};
  }

  if (nodeType === 'text') {
    // 缓存模板
    this.nodeTpl[name] = node.nodeValue;
  }

  this.name = name;
  this.node = node;

  this.vm = vm;
  this.nodeType = nodeType;
  this.update = function () {
    let value = this.vm.data[this.name];
    let reg = /\{\{(.*)\}\}/g; //正则匹配页面指令

    // console.log('up:' + this.nodeType + '_' + this.name, value);
    //  let newNode = document.createElement("div");
    switch (this.nodeType) {
      case 'text':
        value = this.nodeTpl[name].replace(reg, value); //获取匹配到的字符串
        this.node.nodeValue = value;
        break;
      case 'html':
        this.node.innerHTML = value;
        break;
      case 'input':
        this.node.value = value;
        break;
    }
  };
  Dep.target = this;
}

function Dep() {
  this.subs = [];
  (this.addSub = function (sub) {
    // 防止重复添加
    let _isPush = true;
    for (let i = 0; i < this.subs.length; i++) {
      let _sub = this.subs[i];
      if (_sub && _sub.name == sub.name && _sub.nodeType == sub.nodeType) {
        _isPush = false;
      }
    }
    if (_isPush) {
      // console.log('notify.sub', sub);
      this.subs.push(sub);
    }
  }),
    (this.notify = function (key) {
      // console.log('notify', key);
      // 取出当前需要触发更新的事件
      this.subs.forEach(function (sub) {
        if (sub.name === key) {
          sub.update();
        }
      });
    });
}

//记录所有绑定数据的节点
// let watchers = [];

function observer(vm) {
  Object.keys(vm.data).forEach(function (key) {
    let dep = new Dep();
    let value = vm.data[key];
    Object.defineProperty(vm.data, key, {
      get() {
        //  console.log(`获取数据${value}`);
        // 添加订阅者 watcher 到主题对象 Dep
        dep.addSub(Dep.target);
        return value;
      },
      set(newValue) {
        if (newValue === value) return;
        value = newValue;
        //  console.log(`数据更新${value}`);
        //通过该主题的所有订阅者更新数据
        dep.notify(key);
      },
    });
  });
}

//编译解析指令
function compile(node, vm) {
  let reg = /\{\{(.*)\}\}/g; //正则匹配页面指令
  // console.log('compile:' + node.nodeType + '_' + node.nodeName, node.value);
  //元素节点
  if (node.nodeType === 1) {
    // 取出节点属性
    let attr = node.attributes;
    //解析节点的属性
    for (let i = 0; i < attr.length; i++) {
      let name = attr[i].nodeValue; //获取v-model绑定的属性名
      let key = attr[i].nodeName;
      // console.log('bindf:' + key, name);
      if (key === 'v-model') {
        //-------------------------------
        node.addEventListener('input', function (e) {
          vm.data[name] = e.target.value;
        });
        //-----------------------------
        //记录绑定数据的元素节点
        // watchers.push({ name: name, node:node, nodeType: 'input', vm:vm })
        new Watcher(vm, node, name, 'input');
        node.value = vm.data[name]; //将data中的值赋给该节点
        node.removeAttribute(key); //解析完毕不要出现vue指令
      }
      if (key === 'v-html') {
        new Watcher(vm, node, name, 'html');
        node.value = vm.data[name]; //将data中的值赋给该节点
        //  console.log('ht:' + key, node.value)
        node.removeAttribute(key); //解析完毕不要出现vue指令
      }
    }
  }
  //如果节点类型为text
  if (node.nodeType === 3) {
    if (reg.test(node.nodeValue)) {
      let name = RegExp.$1; //获取匹配到的字符串
      name = name.trim();
      //记录绑定数据的文本节点
      // watchers.push({ name:name, node:node, nodeType: 'text', vm:vm })
      new Watcher(vm, node, name, 'text');
      // 绑定
      // console.log('text' + name, node.nodeValue)
      node.nodeValue = node.nodeValue.replace(reg, vm.data[name]); //获取匹配到的字符串

      // node.nodeValue = vm.data[name];
    }
  }
}

function bind(the, dom, flag) {
  let child;
  while ((child = dom.firstChild)) {
    // console.log(
    //   'bind:' + child.nodeType + '_' + child.nodeName,
    //   child.childNodes.length
    // );
    if (child.nodeName != 'BUTTON' && child.childNodes.length > 0) {
      bind(the, child, flag);
    } else {
      compile(child, the); //挂载目标中的节点挨个过滤（解析指令）
    }
    flag.appendChild(child); //放到DocumentFragment页面渲染就不会显示/劫持
  }
  return flag;
}

/**
 * 虚拟组件视图
 */
class View {
  /**
   * new cache({mode:1_标准,2_cookie,key:应用的key,name:存储的主键名})
   * @param {json} options
   */
  constructor(options) {
    this.data = options.data;
    //监听模型数据变化
    observer(this);
    //将挂载目标劫持 -> 存到节点容器中（数据处理） -> 再放到挂载目标中
    let _flag = document.createDocumentFragment();
    // 模板内容绑定
    let dom = document.createElement('div');
    dom.innerHTML = options.template; // document.querySelector(el);
    //  console.log('qvm', options.template)
    bind(this, dom, _flag);
    this._flag = _flag;
  }
  /**
   * 绑定对象
   * @param {*} el 对象
   */
  mount(el) {
    document.querySelector(el).appendChild(this._flag); //将DocumentFragment放到挂载目标中
    return this;
  }
}

export { View };

/*
<div id="app">
<input type="text" v-model="text"> {{text}} <br />
<input type="text" v-model="name"> {{name}}
</div>

var app = new quick.view({
  data: {
    text: 'Well',
    name: 'john'
  }
}).mount('#app')

*/
